import { FunctionComponent, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckIcon from "@mui/icons-material/Check";

interface Props {
	onCopy: () => Promise<void>;
}

const CopyButton: FunctionComponent<Props> = ({ onCopy }) => {
	const [copyState, setCopyState] = useState<"idle" | "loading" | "copied">(
		"idle"
	);

	const handleCopy = async () => {
		if (copyState === "loading") return;
		setCopyState("loading");
		try {
			await onCopy();
			setCopyState("copied");
			setTimeout(() => setCopyState("idle"), 2000);
		} catch {
			setCopyState("idle");
		}
	};

	return (
		<IconButton
			className="cardCopyButton"
			onClick={handleCopy}
			disabled={copyState === "loading"}
			sx={{
				width: "32px",
				height: "32px",
				color: "#7F7F87",
				opacity: 0,
				transition: "opacity 0.15s ease",
			}}
		>
			{copyState === "loading" ? (
				<Box
					sx={{
						width: 16,
						height: 16,
						borderRadius: "50%",
						border: "2px solid rgba(127, 127, 135, 0.3)",
						borderTopColor: "#7F7F87",
						boxSizing: "border-box",
						animation: "cardHeadSpin 0.7s linear infinite",
						"@keyframes cardHeadSpin": {
							"0%": { transform: "rotate(0deg)" },
							"100%": { transform: "rotate(360deg)" },
						},
					}}
				/>
			) : copyState === "copied" ? (
				<CheckIcon sx={{ width: 20, height: 20, color: "#2e7d32" }} />
			) : (
				<ContentCopyOutlinedIcon sx={{ width: 20, height: 20 }} />
			)}
		</IconButton>
	);
};

export default CopyButton;
